//@dependencies
import PropTypes from "prop-types";
//styles
import styles from "./TyTabs.module.scss";

export default function TyTabs(props) {
  //props and hooks
  let {
    tabs,
    selectedTab,
    setSelectedTab,
    defaultTabIndex,
    disable,
    disableFunc,
    ...rest
  } = props;

  return (
    <div className={styles.Container} {...rest}>
      {tabs.map((tab, index) => (
        <div
          className={
            selectedTab.value === tab.value
              ? `${styles.ActiveContainerItem} ActiveNavItem`
              : `${styles.InActiveContainerItem} InActiveNavItem`
          }
          onClick={() => {
            if (disable) {
              tabs[defaultTabIndex].value === tab.value
                ? setSelectedTab( tab)
                : disableFunc();
            } else {
              setSelectedTab(tab);
            }
          }}
          key={index}
        >
          {tab.title}
        </div>
      ))}
    </div>
  );
}

//types
TyTabs.propTypes = {
  tabs: PropTypes.arrayOf({
    title: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  }).isRequired,
  selectedTab: PropTypes.any.isRequired,
  setSelectedTab: PropTypes.func.isRequired,
  defaultTabIndex: PropTypes.number,
  disable: PropTypes.bool,
  disableFunc: PropTypes.func,
};
